import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const CollapseOpen = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 4.75H3C2.58579 4.75 2.25 5.08579 2.25 5.5C2.25 5.91421 2.58579 6.25 3 6.25H12V4.75ZM5.5 12.75C6.4665 12.75 7.25 13.5335 7.25 14.5C7.25 15.4665 6.4665 16.25 5.5 16.25C4.5335 16.25 3.75 15.4665 3.75 14.5C3.75 13.5335 4.5335 12.75 5.5 12.75ZM8.66303 13.75C8.32445 12.3167 7.03679 11.25 5.5 11.25C3.70507 11.25 2.25 12.7051 2.25 14.5C2.25 16.2949 3.70507 17.75 5.5 17.75C7.03679 17.75 8.32445 16.6834 8.66303 15.25L17 15.25C17.4142 15.25 17.75 14.9142 17.75 14.5C17.75 14.0858 17.4142 13.75 17 13.75L8.66303 13.75Z" 
            fill={props.color ? props.color : "white"}/>
            <path fillRule="evenodd" clipRule="evenodd" d="M14.5 9C16.433 9 18 7.433 18 5.5C18 3.567 16.433 2 14.5 2C12.567 2 11 3.567 11 5.5C11 7.433 12.567 9 14.5 9ZM16.5881 3.86431C16.3949 3.69873 16.1013 3.71438 15.9279 3.90247L13.8874 6.11605L13.0529 5.31137C12.8693 5.1343 12.5752 5.1343 12.3916 5.31137C12.2028 5.49337 12.2028 5.79234 12.3916 5.97434L13.5767 7.11719C13.6693 7.20649 13.794 7.2534 13.921 7.2498C14.048 7.2462 14.17 7.19228 14.2573 7.09752L16.6277 4.52609C16.8059 4.33274 16.7866 4.0344 16.5881 3.86431Z" 
            fill='#43B02A'/>
        </SvgStyled>
    );
};

export default CollapseOpen;
